import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, Twitter, Github } from "lucide-react";
import Logo from "@/components/Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#050B14] mt-12"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div className="space-y-4">
          <Logo testId="footer-logo" variant="footer" />
          <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
            We transform ideas into intelligent solutions through AI, Data
            Engineering, and next-generation technology.
          </p>
          <div className="flex items-center gap-3 pt-2">
            <a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-social-linkedin"
              className="w-9 h-9 rounded-md border border-white/10 flex items-center justify-center text-slate-300 hover:text-[#00D4FF] hover:border-[#00D4FF]/40 transition"
              aria-label="LinkedIn"
            >
              <Linkedin size={16} />
            </a>
            <a
              href="https://x.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-social-twitter"
              className="w-9 h-9 rounded-md border border-white/10 flex items-center justify-center text-slate-300 hover:text-[#00D4FF] hover:border-[#00D4FF]/40 transition"
              aria-label="Twitter"
            >
              <Twitter size={16} />
            </a>
            <a
              href="https://github.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-social-github"
              className="w-9 h-9 rounded-md border border-white/10 flex items-center justify-center text-slate-300 hover:text-[#00D4FF] hover:border-[#00D4FF]/40 transition"
              aria-label="GitHub"
            >
              <Github size={16} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-white font-display font-semibold mb-4">Company</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li><Link to="/about" className="hover:text-[#00D4FF]" data-testid="footer-link-about">About</Link></li>
            <li><Link to="/services" className="hover:text-[#00D4FF]" data-testid="footer-link-services">Services</Link></li>
            <li><Link to="/careers" className="hover:text-[#00D4FF]" data-testid="footer-link-careers">Careers</Link></li>
            <li><Link to="/blog" className="hover:text-[#00D4FF]" data-testid="footer-link-blog">Blog</Link></li>
            <li><Link to="/contact" className="hover:text-[#00D4FF]" data-testid="footer-link-contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-display font-semibold mb-4">Services</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li>AI Solutions</li>
            <li>Data Engineering</li>
            <li>Cloud Engineering</li>
            <li>Web Development</li>
            <li>Mobile App Development</li>
            <li>DevOps &amp; Automation</li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-display font-semibold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-start gap-2">
              <Mail size={16} className="text-[#00D4FF] mt-0.5" />
              <a
                href="mailto:hr@tri-nexa.com"
                data-testid="footer-email"
                className="hover:text-[#00D4FF]"
              >
                hr@tri-nexa.com
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Phone size={16} className="text-[#00D4FF] mt-0.5" />
              <a
                href="tel:+919972625368"
                data-testid="footer-phone"
                className="hover:text-[#00D4FF]"
              >
                +91 99726 25368
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={16} className="text-[#00D4FF] mt-0.5" />
              <span>Bangalore, Karnataka, India</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p data-testid="footer-copy">© {year} TriNexa. All rights reserved.</p>
          <p className="font-mono-tech tracking-widest uppercase">
            tri-nexa.com
          </p>
        </div>
      </div>
    </footer>
  );
}
